// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@5.2.7_webpack@4.41.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".price.price-static{display:none}.input-group{max-width:14rem}label{font-weight:400;display:block;margin-bottom:1rem;font-size:1.2em}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
